/** Public homepage pricing section — cards come from the admin-editable
 * `pricing_cards` setting via the shared PricingCards component. */
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Sparkles } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { usePublicSettings } from "@/lib/siteSettings";
import { renderRich } from "@/lib/richText";
import { HOMEPAGE_DEFAULTS } from "@/lib/homepageDefaults";
import PricingCards from "@/components/PricingCards";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const PricingSection = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const settings = usePublicSettings();
  const content = { ...HOMEPAGE_DEFAULTS.pricing, ...(settings["homepage.pricing"] || {}) };
  const [promo, setPromo] = useState(null);

  useEffect(() => {
    axios.get(`${API}/public/active-promo`)
      .then((r) => setPromo(r.data && r.data.code ? r.data : null))
      .catch(() => setPromo(null));
  }, []);

  if (content.show === false) return null;

  const handleSelect = (card) => {
    const plan = card?.plan_key;
    if (!plan) return navigate("/signup");
    navigate(user ? `/billing?plan=${plan}` : `/signup?checkout=${plan}`);
  };

  return (
    <section id="pricing" className="py-24 px-6 border-t border-border" data-testid="pricing-section">
      <div className="max-w-5xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold text-center mb-3">
          {renderRich(content.heading, "text-primary")}
        </h2>
        <p className="text-muted-foreground text-center mb-12 max-w-xl mx-auto text-sm">
          {content.subheading}
        </p>

        <PricingCards onSelect={handleSelect} />

        <p className="text-center text-xs text-muted-foreground mt-8 inline-flex items-center gap-1.5 w-full justify-center" data-testid="pricing-promo-line">
          <Sparkles className="w-3.5 h-3.5 text-accent" />
          {promo ? (
            <>
              {promo.name} - {promo.percent_off ? `${promo.percent_off}% off` : `AU$${((promo.amount_off_cents || 0) / 100).toFixed(0)} off`} with code <span className="font-mono font-bold">{promo.code}</span> at checkout · cancel anytime
            </>
          ) : (
            <>{content.guarantee_line}</>
          )}
        </p>
      </div>
    </section>
  );
};

export default PricingSection;
